import DynamicComponent from './DynamicComponent'
import SbEditable from 'storyblok-react'

const Page = ({content, full,  published_at, slug}) => (  
  
    <main>
      {
        // console.log("pages", content)
      }
      {content && content.content && content.content.map((blok) =>
        <DynamicComponent blok={blok} key={blok._uid} full={full} published_at={published_at} slug={slug}/>
      )}
    </main>
  
)

export default Page;
